import { useDispatch, useSelector } from 'react-redux';
import { confirmjobHistoryActions } from '../reducers/customer-info-job-history.reducer';
import { CustomerInfoJobHistoryState, RootState } from '../types/store.types';

export const useConfirmJobsHistoryStore = () => {
  const userJobHistoryStore = useSelector<RootState, CustomerInfoJobHistoryState>((state) => state.jobHistory);
  const dispatch = useDispatch();
  const { jobsHistoryData, filterJobHistoryList } = confirmjobHistoryActions;

  return {
    dispatch,
    userJobHistoryStore,
    jobsHistoryData,
    filterJobHistoryList,
  };
};
